// 📡 sellox.shop landing visitor tracking (public pages only).
// Skips: super-admin devices (logged in without tenant), devices opted out via "不记录我" (sx_no_track=1).
const isOwnDevice = () => {
  try {
    if (localStorage.getItem("sx_no_track") === "1") return true;
    const u = JSON.parse(sessionStorage.getItem("cached_auth_user") || localStorage.getItem("cached_auth_user") || "null");
    return !!(u && u.role === "admin" && !u.tenant_id);
  } catch { return false; }
};

export function trackLanding(event, extra = {}) {
  try {
    if (isOwnDevice()) return;
    if (!window.__sxLvOpenAt) {
      window.__sxLvOpenAt = Date.now();
      // "left the page" beacon with seconds spent → super admin sees "停了 20 秒，没提交"
      window.addEventListener("pagehide", () => {
        try {
          if (isOwnDevice()) return;
          const sid = sessionStorage.getItem("sx_lv_sid"), vid = localStorage.getItem("sx_lv_vid");
          if (!sid) return;
          const dur = Math.round((Date.now() - window.__sxLvOpenAt) / 1000);
          navigator.sendBeacon?.(`${process.env.REACT_APP_BACKEND_URL || ""}/api/landing/track`,
            new Blob([JSON.stringify({ sid, vid, event: "leave", dur, path: window.location.pathname })], { type: "application/json" }));
        } catch { /* ignore */ }
      }, { once: true });
    }
    let sid = sessionStorage.getItem("sx_lv_sid");
    if (!sid) { sid = Math.random().toString(36).slice(2) + Date.now().toString(36); sessionStorage.setItem("sx_lv_sid", sid); }
    let vid = localStorage.getItem("sx_lv_vid");
    if (!vid) { vid = "v" + Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem("sx_lv_vid", vid); }
    const q = new URLSearchParams(window.location.search);
    const utm = ["utm_source", "utm_medium", "utm_campaign"].map(k => q.get(k)).filter(Boolean).join(" / ");
    fetch(`${process.env.REACT_APP_BACKEND_URL || ""}/api/landing/track`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        sid, vid, event: event || "",
        path: window.location.pathname + (window.location.hash || ""),
        ref: document.referrer || "", utm,
        device: /Mobi|Android/i.test(navigator.userAgent) ? "mobile" : "desktop",
        lang: navigator.language || "",
        screen: `${window.screen?.width || 0}x${window.screen?.height || 0}`,
        tz: (Intl.DateTimeFormat().resolvedOptions().timeZone || ""),
        ...extra,
      }),
    }).catch(() => {});
  } catch { /* ignore */ }
}
